/** yyyy-MM-dd */
export type DateString = string;

export interface AnalyticsPeriod {
  startDate: DateString;
  endDate: DateString;
}

export const PeriodPresetKeys = {
  YESTERDAY: "YESTERDAY",
  LAST_7_DAYS: "LAST_7_DAYS",
  LAST_30_DAYS: "LAST_30_DAYS",
  THIS_MONTH: "THIS_MONTH",
} as const;
export type PeriodPresetKey =
  (typeof PeriodPresetKeys)[keyof typeof PeriodPresetKeys];

/** 집계 테이블에서 내려오는 건수. 요약과 경향 버킷이 같은 모양을 쓴다. */
export interface CompanyStatsCounts {
  avgDau: number;
  /** 등록 화물 건수 (취소 포함) */
  registCargoCnt: number;
  totalDispatchCnt: number;
  infoNetUsingCnt: number;
  progDispatchCnt: number;
  /** 오더 총 건수 (취소 제외) */
  orderCnt: number;
}

// --- 요약 (Company-Summary) ---
export interface CompanyStatsSummary extends CompanyStatsCounts {
  companyGuid: string;
  startDate: DateString;
  endDate: DateString;
  /** 실제로 집계가 반영된 마지막 날짜. 배치가 어제까지만 집계하므로 종료일보다 이를 수 있다 */
  aggregatedThrough: DateString | null;
  /** 평균 DAU 의 분모 */
  dayCount: number;
  /** orderCnt 가 아직 백필되지 않은 일수. 0보다 크면 orderCnt 가 실제보다 작다 */
  orderCntMissingDays: number;
}

// --- 경향 (Company-Trend) ---
export const TrendRanges = {
  WEEK: "WEEK",
  MONTH: "MONTH",
  QUARTER: "QUARTER",
  YEAR: "YEAR",
} as const;
export type TrendRange = (typeof TrendRanges)[keyof typeof TrendRanges];

export type TrendUnit = "DAY" | "WEEK" | "MONTH";

export interface CompanyStatsTrendPoint extends CompanyStatsCounts {
  /** 버킷 시작일. 주 단위는 월요일, 월 단위는 1일 */
  bucketStart: DateString;
}

export interface CompanyStatsTrend {
  companyGuid: string;
  range: TrendRange;
  unit: TrendUnit;
  startDate: DateString;
  endDate: DateString;
  points: CompanyStatsTrendPoint[];
}

export interface TrendTarget {
  companyGuid: string;
  companyName: string;
}

export interface FetchAllProgress {
  total: number;
  done: number;
  failed: number;
  currentName: string | null;
}
